import PqIntensityDiagram from './PqIntensityDiagram';
export default PqIntensityDiagram;
